import { Fragment} from "react";
import { Transition, Menu } from "@headlessui/react";
import MenuItem from "../MenuItem";
import {Link, useNavigate} from 'react-router-dom'
import { loggedInUser } from "../../../features/Auth/Auth_Slice";
import { useSelector } from "react-redux";
import { PowerIcon } from "@heroicons/react/24/outline";


function DropDownMenu({children,caretSvg,btnIcon,dropdownItemsList=[]}) {

  const user = useSelector(loggedInUser);
  const navigate = useNavigate();

  const handleOnClick = () => {
      navigate("/login")
  }

    return (  
        <Menu as="div" className="relative" onClick={user && user?.isAuthenticated ? undefined : handleOnClick}>
        {({open}) => (
          <>
            <Menu.Button onMouseEnter={(e)=> open ? null : e.currentTarget.click()}  className="relative shadow-sm inline-flex items-center border-gray-200 border-[1px] px-3 py-2 text-sm font-medium text-center text-gray-900 bg-gray-50 rounded-lg md:mb-0 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-100">
               {btnIcon}
               <span className="text-sm hidden  md:inline-flex">
                 {children}
               </span> 
              {caretSvg ?  <svg className="w-2 h-2 ml-2 hidden sm:inline-flex" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6"> <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4"/></svg>
                 : null
               }
             </Menu.Button>

        <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100"  leaveTo="transform opacity-0 scale-95">
             <Menu.Items className="absolute lg:left-0 -right-20 z-20 mt-2 w-64 origin-top-right rounded-lg bg-white py-1 dropdown-shadow ring-1 ring-black ring-opacity-5 focus:outline-none">
                  {/* Sign in button */}
                  {!user && !user?.isAuthenticated &&
                  <>
                 
                  {/* Signup button */}
                      <Menu.Item className="border-gray-200	border-b-[1px]">
                         <Link to="/register" className="w-full flex justify-between bg-white group py-3 text-sm font-medium text-gray-700 group-hover:text-gray-900">
                               <div className="inline-flex items-center cursor-pointer group-hover:text-gray-900">
                                   <h3 className="pl-4 mr-3 text-base"> New Customer?</h3>
                               </div>
                             <div className="px-4 text-indigo-600">
                                <h3 className="text-base font-bold"> Sign Up </h3>
                             </div>
                           </Link>
                     </Menu.Item>
                     </>
                    }
                 {/* Remaining Menu Buttons */}
                      {dropdownItemsList && dropdownItemsList.map((item)=>(
                         <MenuItem key={item.name} url={item.url} id={item.name} name={item.name} icon={item.icon} />
                     ))}
                      
                      {user && user?.isAuthenticated &&
                      <MenuItem key="Signout" url="/signout" id="Signout" name="Signout" icon={<PowerIcon className="w-5 h-5 text-gray-700 group-hover:text-gray-900" />} />
                      }

               </Menu.Items>
          </Transition>
          </>
        )}
      </Menu>
    );
}

export default DropDownMenu;